import { ContractorType as ContractorTypeModel } from '@insurance/api/requests'
import { Form } from 'antd'
import { useEffect } from 'react'

import { ContractorTypeFields } from '../PersonsFields'
import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { ContractTypeCode } from './type'
import { formProps, MIN_AGE } from './utils'

export const ContractorType = () => {
  const { isEditable } = useAccidentInsuranceValues()
  const { sameContractorKey, personsStr, contractorProps, contractTypeProps } =
    formProps()

  const contractType = Form.useWatch(contractTypeProps.name, { preserve: true })
  const personsDocument = Form.useWatch(personsStr.name, {
    preserve: true
  })
  const formInstance = Form.useFormInstance()

  const hasPersonsDocumentFile = !!personsDocument?.fileList?.[0]
  const isCollective = contractType === ContractTypeCode.COLLECTIVE

  useEffect(() => {
    if (hasPersonsDocumentFile)
      formInstance.setFieldValue(sameContractorKey.name, false)
  }, [formInstance, hasPersonsDocumentFile, sameContractorKey.name])

  useEffect(() => {
    if (isCollective)
      formInstance.setFieldValue(
        [contractorProps.name, 'content_type'],
        ContractorTypeModel.LEGALENTITY
      )
  }, [isCollective, contractorProps.name, formInstance])

  return (
    <ContractorTypeFields
      isEditable={isEditable}
      minAge={MIN_AGE}
      resident
      sameContractorKey={sameContractorKey.name}
      showSameContractorField={!hasPersonsDocumentFile}
      disableContractorType={isCollective}
    />
  )
}
